import { render } from "./YearTotalTarget.vue?vue&type=template&id=562b3da6&scoped=true"
import script from "./YearTotalTarget.vue?vue&type=script&lang=js"
export * from "./YearTotalTarget.vue?vue&type=script&lang=js"

import "./YearTotalTarget.vue?vue&type=style&index=0&id=562b3da6&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562b3da6"]])

export default __exports__